import { useContext } from "react";
import useGet from "./useGet";
import { DetailsActionContext } from "./DetailsActionContext";
import { useNavigate } from "react-router-dom";
import {TenantAndCommerceContext} from "@main/contexts/TenantAndCommerceContext";
import OrderDetails from "@beeldit/ecommerce/orders/components/OrderDetails";
import useChangeStatusAction from "@beeldit/ecommerce/orders/actions/change-status/useChangeStatusAction";
import useDownloadShipmentLabelAction
  from "@beeldit/ecommerce/orders/actions/download-shipment-label/useDownloadShipmentLabelAction";
import useUploadInvoiceAction from "@beeldit/ecommerce/orders/actions/upload-invoice/useUploadInvoiceAction";
import useDownloadInvoiceAction from "@beeldit/ecommerce/orders/actions/download-invoice/useDownloadInvoiceAction";

function useDetailsAction(id: number): any {
  const navigate = useNavigate();

  const { tenantId, commerceId } = useContext(TenantAndCommerceContext);

  const detailsFunction = (id: any) => {
    navigate(`/panel/${tenantId}/${commerceId}/producer/order/${id}`);
  };

  const get = useGet();
  const getFunction = (id: number) => get(id);

  const { element } = useContext(DetailsActionContext);

  const onSuccess = () => {
    getFunction(element.id)
  }

  const { prepareChangeStatusFunction, actionTemplate: changeStatusActionTemplate  } =
      useChangeStatusAction(onSuccess);

  const { downloadShipmentLabelFunction  } = useDownloadShipmentLabelAction();

  const { prepareUploadInvoiceFunction, actionTemplate: uploadInvoiceActionTemplate  } =
      useUploadInvoiceAction(onSuccess);

  const { downloadInvoiceFunction } = useDownloadInvoiceAction();


  const actionTemplate = <OrderDetails order={element} prepareChangeStatusFunction={prepareChangeStatusFunction}
                                       downloadShipmentLabelFunction={downloadShipmentLabelFunction}
                                       prepareUploadInvoiceFunction={prepareUploadInvoiceFunction}
                                       downloadInvoiceFunction={downloadInvoiceFunction}/>;

  /** END EDIT FORM ACTION */

  return {
    detailsFunction,
    getFunction,
    actionTemplate,
    changeStatusActionTemplate,
    uploadInvoiceActionTemplate,
    element,
  };
}

export default useDetailsAction;
